import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import serverVars from 'server-vars';
import get from 'lodash.get';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { getRecentHistoryList } from 'dibs-recent-history/exports/getRecentHistory';
import { SharedRecentlyViewedItemsCarousel } from './SharedRecentlyViewedItemsCarousel';
import { SharedRecentlyViewedItemsSwiper } from '../SharedRecentlyViewedItemsSwiper/SharedRecentlyViewedItemsSwiper';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './SharedRecentlyViewedItems.scss';
import {
    VERTICAL_OFFSET_RESP_IMG,
    HORIZONTAL_OFFSET_RESP_IMG,
} from '../../constants/imageConstants';

const recentlyViewed = (
    <FormattedMessage id="shared.recentlyViewed" defaultMessage="Recently Viewed" />
);

export const SharedRecentlyViewedItemsComponent = ({
    itemId,
    isClient,
    wrapperClassName,
    arrowClassName,
    placeholderClassName,
    itemImageClassName,
    showBarHeader,
    itemsPerPage,
    user,
}) => {
    const recentHistoryItems = get(user, 'recentHistoryList');
    const items = getRecentHistoryList({ itemId, recentHistoryItems, isClient });
    if (!isClient || !items || !items.length) {
        return null;
    }

    const itemClasses = classnames(styles.item, { [styles.center]: items && items.length < 3 });
    const header = showBarHeader ? (
        <BarHeader title={recentlyViewed} />
    ) : (
        <p className={styles.header}>{recentlyViewed}</p>
    );
    return (
        <Fragment>
            {header}
            {serverVars.get('settings.isTablet') ? (
                <SharedRecentlyViewedItemsSwiper
                    items={items}
                    itemsPerPage={4.5}
                    offsetVertical={VERTICAL_OFFSET_RESP_IMG}
                    offsetHorizontal={HORIZONTAL_OFFSET_RESP_IMG}
                    classNames={{
                        wrapper: wrapperClassName || styles.swiperWrapper,
                        item: itemClasses,
                        list: items && items.length > 5 ? '' : styles.list,
                        placeholder: placeholderClassName || styles.placeholder,
                        itemImage: itemImageClassName || styles.itemImage,
                    }}
                />
            ) : (
                <SharedRecentlyViewedItemsCarousel
                    items={items}
                    itemsPerPage={itemsPerPage}
                    classNames={{
                        list: items && items.length > itemsPerPage ? '' : styles.list,
                        placeholder: styles.placeholder,
                        itemLink: styles.itemLink,
                        itemImage: styles.itemImage,
                        arrow: arrowClassName,
                        wrapper: wrapperClassName || styles.carouselWrapper,
                    }}
                />
            )}
        </Fragment>
    );
};

SharedRecentlyViewedItemsComponent.defaultProps = {
    showBarHeader: true,
    itemsPerPage: 6,
};

SharedRecentlyViewedItemsComponent.propTypes = {
    arrowClassName: PropTypes.string,
    wrapperClassName: PropTypes.string,
    placeholderClassName: PropTypes.string,
    itemImageClassName: PropTypes.string,
    itemId: PropTypes.string,
    isClient: PropTypes.bool.isRequired,
    showBarHeader: PropTypes.bool.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    user: PropTypes.object,
};

export const SharedRecentlyViewedItems = createFragmentContainer(
    SharedRecentlyViewedItemsComponent,
    {
        user: graphql`
            fragment SharedRecentlyViewedItems_user on User {
                ...getRecentHistory_user @relay(mask: false)
            }
        `,
    }
);
